import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { GlobalAction } from '@ps20-frontend/shop-integration-redux';
import { EinstiegResponse } from '@ps20/bff-models';
import { ItemCached } from './actionPayloadModels/itemCached';

export class LocalActions {
  static readonly ITEM_CACHED = 'ITEM_CACHED';
  static readonly APP_IS_INITIALIZED = 'APP_IS_INITIALIZED';
  static readonly LOAD_APP_CONFIG = 'LOAD_APP_CONFIG';
  static readonly APP_CONFIG_LOADED = 'APP_CONFIG_LOADED';
  static readonly SESSION_EXPIRED = 'SESSION_EXPIRED';
  static readonly VN_ADDRESS_INVALID = 'VN_ADDRESS_INVALID';
  static readonly VN_ADDRESS_INVALID_PAGE_REQUESTED = 'VN_ADDRESS_INVALID_PAGE_REQUESTED';
  static readonly VN_ADDRESS_INVALID_CONFIRMED = 'VN_ADDRESS_INVALID_CONFIRMED';
}

export function createItemCachedAction(itemCached: ItemCached): GlobalAction<ItemCached> {
  return {
    type: LocalActions.ITEM_CACHED,
    payload: itemCached,
  };
}

export type ItemCachedAction = ReturnType<typeof createItemCachedAction>;

export function appIsInitilized(): AnyAction {
  return {
    type: LocalActions.APP_IS_INITIALIZED,
  };
}

export function loadAppConfig(appId: App): GlobalAction<{ appId: App }> {
  return {
    type: LocalActions.LOAD_APP_CONFIG,
    payload: {
      appId,
    },
  };
}
export type LoadAppConfigAction = ReturnType<typeof loadAppConfig>;

export function appConfigLoaded(
  appId: App,
  filename: string,
): GlobalAction<{ appId: App; filename: string }> {
  return {
    type: LocalActions.APP_CONFIG_LOADED,
    payload: {
      appId,
      filename,
    },
  };
}
export type AppConfigLoadedAction = ReturnType<typeof appConfigLoaded>;

export function sessionExpired(): AnyAction {
  return {
    type: LocalActions.SESSION_EXPIRED,
  };
}

export const vnAddressInvalid = (payload: EinstiegResponse): GlobalAction<EinstiegResponse> => {
  return {
    type: LocalActions.VN_ADDRESS_INVALID,
    payload,
  };
};

export const vnAddressInvalidPageRequested = (): AnyAction => {
  return {
    type: LocalActions.VN_ADDRESS_INVALID_PAGE_REQUESTED,
  };
};

export const vnAddressInvalidConfirmed = (): AnyAction => {
  return {
    type: LocalActions.VN_ADDRESS_INVALID_CONFIRMED,
  };
};
